import { ENDPOINT } from 'api/endPoints/getActivityPrediction';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { LARGE_SHORT, MEDIUM_SHORT } from 'components/Dashboards/Reporting/reportingConfig';

export const finishDateOverallSummary: IHashmapItemComponentProps = {
    NoPermissionMessage,
    globalFiltersConfig: [{ key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null }],
    reportStyle: {
        widgetSizesAvailable: {
            mediumShort: MEDIUM_SHORT,
            largeShort: LARGE_SHORT,
        },
        widgetInitialSize: MEDIUM_SHORT,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: true,
        },
        hideNarrativeEditor: true,
    },
    endpoint: ENDPOINT,
    title: 'Finish Date Prediction',
    id: 'finishDate-overall-summary',
    componentKey: 'finishDateOverallSummary',
};
